import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationGenerateOutlineSubtopicsArgs,
  BackendSubtopics,
} from 'src/types/backend';

const MUTATION = gql`
  mutation GenerateOutlineSubtopics(
    $projectId: ID!
    $type: GenerateSubtopicTypeEnum!
    $cursor: String
    $documentId: ID
    $url: String
  ) {
    generateOutlineSubtopics(
      projectId: $projectId
      type: $type
      cursor: $cursor
      documentId: $documentId
      url: $url
    ) {
      cursor
      subtopics {
        subtopic
        details
        name
        url
      }
    }
  }
`;

type Variables = BackendMutationGenerateOutlineSubtopicsArgs;
type Result = BackendSubtopics;

export const generateOutlineSubtopics = async (
  variables: Variables
): Promise<Result | undefined> => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });
  return getSingleProp<Result>(result.data);
};
